module.exports = __webpack_public_path__ + "img/left.9720a6e0.png";